import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  userEmail: string = localStorage.getItem("user_email");
  constructor( private router: Router,private apiService: ApiService) { }

  ngOnInit() {
    console.log('here')
    this.apiService.getDepartments()
    .subscribe((res: any) => {
      if(res.status === 'Success') {       
        localStorage.setItem('departments',JSON.stringify(res.data));
      }
    }, (err) => {
        
    });



    if(this.userEmail != null)
    {
      this.router.navigateByUrl('/procurement/team');
    }
  }

  login()
  {
    this.router.navigateByUrl('/session/login');
  }

  register()
  {
    this.router.navigateByUrl('/session/verify');
  }

}
